export default __webpack_public_path__ + "static/media/gallery-16.e098288d.jpg";